import api from ".";
import { MmOrder, MmOrderType } from "../modules/treasury/types/mm-order.type";
import { MmTradeRecord } from "../modules/treasury/types/mm-trade-record.type";

export const marketMakerApi = {
  getOrderBook: async (
    token: string
  ): Promise<Record<MmOrderType, MmOrder[]>> => {
    return (await api.get(`/market-maker/order-book/${token}`)).data;
  },
  getLatestTrades: async (
    token: string,
    nonMmTrade = false
  ): Promise<MmTradeRecord[]> => {
    return (
      await api.get(`/market-maker/trade-records/${token}`, {
        params: {
          nonMmTrade: nonMmTrade ? "true" : "false",
        },
      })
    ).data;
  },
};
